import React,{useEffect} from 'react';
import { useCombined } from '../../../common/base/CombinedContext';

const SetSiteBreadCrum = ({config,meta}) => {
  const { setBreadcrumbItems } = useCombined()

  const getRouteBasedBreadcrumb = () => {
    const pathName = ((window && window.location && window.location.pathname) || '').toLowerCase();

    if (pathName.includes('/whats-new') || pathName.includes('/whats_new')) {
      return [
        { title: "Cisco IT APIs", url: "/" },
        { title: "What's New", url: "" }
      ];
    }

    return null;
  };

  const getMetaBreadCrumbItems = () => {
    if(meta.page_type === 'home') {
        return ([
            { title: "Cisco IT APIs", url: "" }
          ])
    }
    if(meta.page_type === 'site') {
        return ([
            { title: "Cisco IT APIs", url: "/" },
            {title: meta.site_page_name, url:""}
          ])
    }

    if(meta.page_type === 'apiGroup') {
        return ([
            { title: "Cisco IT APIs", url: "/" },
            {title: meta.site_page_name, url:meta.site_page_url},
            {title: meta.api_group_page_name, url:""}
          ])
    }

    if (meta.site_page_name) {
      return [
        { title: "Cisco IT APIs", url: "/" },
        { title: meta.site_page_name, url: "" }
      ];
    }

    return [];
  }

  const getBreadCrumbItems = () => {
    const metaItems = getMetaBreadCrumbItems();

    if (metaItems && metaItems.length > 1) {
      return metaItems;
    }

    const routeBasedItems = getRouteBasedBreadcrumb();
    if (routeBasedItems) {
      return routeBasedItems;
    }

    return metaItems;
  }

  useEffect(() => {
    const breadcrumbItems = getBreadCrumbItems();

    setBreadcrumbItems(breadcrumbItems);
  }, [setBreadcrumbItems, meta]);

return null;
}
export default SetSiteBreadCrum;